import { Profile, User } from '@bioliberty/lifemind';

export function hasMultiClinicAccess({ subtenants }: Profile): boolean {
  return !!subtenants && subtenants.length > 1;
}

export function formatUserName(user: User): string {
  return `${user.firstName} ${user.lastName}`.trim();
}

export function getSubtenantLabel(user: Profile, subtenantId: string): string {
  return user.subtenants?.find((s) => s.name === subtenantId)?.label ?? subtenantId;
}
